import { render, staticRenderFns } from "./SaleLinkQr.vue?vue&type=template&id=148c9a30"
import script from "./SaleLinkQr.vue?vue&type=script&lang=js"
export * from "./SaleLinkQr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports